export default __webpack_public_path__ + "static/enable-session-replay-in-project-settings-light-mode-a4927bd5246bcc60a37dc1fa181e885f.png";